import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ErrorViewComponent } from "./error-view/error-view.component";
import { InputToggleComponent } from "./input-toggle/input-toggle.component";
import { InputComponent } from "./input/input.component";
import { NebularModule } from "@app/shared/nebular.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "@app/shared/shared.module";
import { TableComponent } from "./table/table.component";
import { FileUploadComponent } from "./file-upload/file-upload.component";
import { InputDropdownComponent } from './input-dropdown/input-dropdown.component';
import { PageViewNavComponent } from './page-view-nav/page-view-nav.component';
import { RouterModule } from "@angular/router";
import { CodeViewerComponent } from './code-viewer/code-viewer.component';
import { FrameworkModule } from "@app/framework/framework.module";

@NgModule({
  declarations: [
    ErrorViewComponent,
    InputToggleComponent,
    InputComponent,
    TableComponent,
    FileUploadComponent,
    InputDropdownComponent,
    PageViewNavComponent,
    CodeViewerComponent
  ],
  imports: [
    FrameworkModule,
    RouterModule,
    CommonModule,
    NebularModule,
    FormsModule,
    ReactiveFormsModule,
    NebularModule,
    SharedModule,
  ],
  exports: [
    PageViewNavComponent,
    CodeViewerComponent,
    ErrorViewComponent,
    InputToggleComponent,
    InputComponent,
    TableComponent,
    FileUploadComponent,
    InputDropdownComponent
  ],
})
export class GenericModule {}
